import useIdToFindResourceList from '@/views/creative/utils/use-id-to-find-resource-list.js'

export const groupItemMixin = {
  props: {
    category: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      submitting: false,
    }
  },

  computed: {
    /**
     * 资源列表
     */
    resourceList() {
      if (this.templateConfig && this.category) {
        const list = useIdToFindResourceList({
          resource: this.templateConfig.resource,
          id: this.category.id,
        })
        return list || []
      }
      return []
    },

    /**
     * json_config 配置信息
     */
    presetConf() {
      const value = this.templateConfig.json_config[this.category.prefix]
      if (typeof value !== 'undefined') return value
      return null
    },
  },
}

export const jsonGroupItemMixin = {
  props: {
    templateConfig: {
      type: Object,
    },

    activeCategoryId: {
      type: Number,
    },
  },

  methods: {},
}
